// @flow

import type {
  IntegrationLogInAction,
  LogInResponse,
  LogInAction,
  LogInExternalUserAction,
  LogInSuccessAction,
  LogInFailureAction,
  SignOutAction
} from '../common/typings';

export const INTEGRATION_LOG_IN = 'INTEGRATION_LOG_IN';
export const LOG_IN = 'LOG_IN';
export const LOG_IN_EXTERNAL_USER = 'LOG_IN_EXTERNAL_USER';
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
export const LOG_IN_FAILURE = 'LOG_IN_FAILURE';
export const SIGN_OUT = 'SIGN_OUT';

export function integrationLogIn(
  orgId: string,
  staffId: string,
  origin: string,
  nonce: string,
  usTimeFormat: boolean,
  kioskSessionId: number | null
): IntegrationLogInAction {
  return {
    type: INTEGRATION_LOG_IN,
    payload: {
      orgId,
      staffId,
      origin,
      nonce,
      usTimeFormat,
      kioskSessionId
    }
  };
}

export function logIn(pin: string): LogInAction {
  return {
    type: LOG_IN,
    payload: {
      pin
    }
  };
}

export function logInExternalUser(externalUserId: string): LogInExternalUserAction {
  return {
    type: LOG_IN_EXTERNAL_USER,
    payload: {
      externalUserId
    }
  };
}

export function logInSuccess(data: LogInResponse): LogInSuccessAction {
  return {
    type: LOG_IN_SUCCESS,
    payload: {
      data
    }
  };
}

export function logInFailure(reason: Error): LogInFailureAction {
  return {
    type: LOG_IN_FAILURE,
    payload: {
      reason
    }
  };
}

export function signOut(): SignOutAction {
  return {
    type: SIGN_OUT
  };
}
